import Axios from "@/utils/Axios";
import config from "@/config";

export interface PostOrderListType {
  page_index: number;
  page_size: number;
}
// 查询用户订单列表-Post
export const postOrderList = async (data: PostOrderListType) => {
  return Axios.post("/v1/order/list", data, {}, config.aiCreator);
};
